export const MAX_SELECTOR_DATA = 2500;
